import type { VoidFunctionComponent } from 'react';

import { icons, IconText } from '../../generic';
import type { SnippetIssueCounts } from '../../../../shared/snippets';

import styles from './LicenseIssueCounts.module.less';

type Props = {
  issueCounts: SnippetIssueCounts;
};

const LicenseIssueCounts: VoidFunctionComponent<Props> = ({ issueCounts }) => {
  const { approved, denied, flagged, unknown } = issueCounts;
  return (
    <div className={styles.licenseIssueCounts}>
      <div className={styles.iconGreen}>
        <IconText icon={icons.check} text={approved.toString()} />
      </div>
      <div className={styles.iconRed}>
        <IconText icon={icons.xMark} text={denied.toString()} />
      </div>
      <div className={styles.iconYellow}>
        <IconText icon={icons.flagOutline} text={flagged.toString()} />
      </div>
      <div>
        <IconText icon={icons.circleQuestion} text={unknown.toString()} />
      </div>
    </div>
  );
};

export default LicenseIssueCounts;
